import React from 'react';
import StoryboardView from './StoryboardView';

interface StoryboardViewContainerProps {
    activeStoryboardHashid: string;
    activeStoryUrl: string;
    activeStoryboardUrl: string;
    activeStoryObject: string;
    hideNavigation?: boolean;
}

const StoryboardViewContainer = React.memo<StoryboardViewContainerProps>(({
    activeStoryboardHashid,
    activeStoryUrl,
    activeStoryboardUrl,
    activeStoryObject,
    hideNavigation = false,
}) => (
    <StoryboardView
        key={`${activeStoryboardHashid}-${activeStoryUrl}-${activeStoryboardUrl}-${activeStoryObject}`}
        activeStoryboardHashid={activeStoryboardHashid}
        activeStoryUrl={activeStoryUrl}
        activeStoryboardUrl={activeStoryboardUrl}
        activeStoryObject={activeStoryObject}
        hideNavigation={hideNavigation}
    />
));

export default StoryboardViewContainer; 